import { HStack } from "@chakra-ui/react"
import { Form, UI } from "components"

export default function Searchable({ value, children, onChange = () => {}, ...props}){

    let timeout = null;

    const handleChange = event => {
        var searchText = event.target.value; // this is the search text
        if(timeout) clearTimeout(timeout)
        timeout = setTimeout(function(){ if(searchText.length >= 3 || searchText.length <= 0) onChange(searchText) } , 1000)
    }
    
    return(
    <HStack borderRadius={4} p={2} backgroundColor="rgba(0,0,0,0.1)" minW="300px">
        <UI.Icon name="search" ml={2} fontSize="25px" color="GrayText" />
        <Form.Text type="search" autocomplete="off" defaultValue={value} onChange={handleChange} fontWeight="bold" border={0} {...props} />
        {children}
    </HStack>
    )
}